module.exports = "<ea-message-outbox-page></ea-message-outbox-page>"


//////////////////
// WEBPACK FOOTER
// ./src/ui/modules/eaMessage/eaMessageOutbox/eaMessageOutboxPage/eaMessageOutboxPageModule.html
// module id = 1038
// module chunks = 12